import React from 'react';
import DynamicPageSections from './DynamicPageSections';
import { useSiteStructureSections } from '../../hooks/useSiteStructureSections';

type Props = { route: string; fallback: React.ReactNode };

const CmsManagedInfoPage: React.FC<Props> = ({ route, fallback }) => {
  const { sections, ready } = useSiteStructureSections(route);

  if (!ready) {
    return (
      <div className="min-h-screen flex flex-col bg-gray-50 pt-16">
        <main className="flex-grow flex items-center justify-center text-gray-500 text-sm">Loading…</main>
      </div>
    );
  }

  if (sections.length === 0) {
    return <>{fallback}</>;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 pt-16">
      <main className="flex-grow">
        <DynamicPageSections sections={sections} />
      </main>
    </div>
  );
};

export default CmsManagedInfoPage;
